<template>
	<el-dialog title="上期内容" :close-on-click-modal="false" :visible.sync="subVisible" width="922px">
		<el-row class="kind_row">
			<el-col :span="8">
				<span class="kind_label">类型</span>
				<span class="kind_value_left">{{ progressKindName }}</span>
			</el-col>
		</el-row>
		<el-table :row-style="selectRowBackground" :row-class-name="tableRowClassName" ref="dataListTable" :header-cell-style="headClass"
			class="dataListTable" :data="dataList" header-align="center" header-cell-class-name="dataListTHeader"
			@selection-change="handleSelectionChange" :cell-style="{ padding: '0px' }" style="margin-bottom: 20px;">
			<el-table-column type="selection" width="45" align="center"></el-table-column>
			<el-table-column label="No." width="70" align="center">
				<template slot-scope="scope">
					{{ (pageIndex2 - 1) * pageSize + scope.$index + 1 }}
				</template>
			</el-table-column>
			<el-table-column prop="descContent" label="内容" align="left" min-width="250" >
			</el-table-column>
			<el-table-column prop="" label="" align="center" width="150" show-overflow-tooltip>
				<template slot-scope="scope">
					{{ scope.row.updDate }} {{ scope.row.updUserName }}
				</template>
			</el-table-column>
		</el-table>
		<el-pagination class="my-pagination" @size-change="sizeChangeHandle" @current-change="currentChangeHandle"
			:current-page="pageIndex" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage"
			layout="total, sizes, prev, pager, next, jumper">
		</el-pagination>
		<el-row class="formBtnGroup">
			<el-col :span="24">
				<el-button class="btn" type="primary" size="small" @click="dataSubmit()"
					:disabled="disabledSaved">保存</el-button>
			</el-col>
		</el-row>
	</el-dialog>
</template>

<script>
import $common from "@/utils/common.js"
export default {
	name: "choose-progress-record",
	data() {
		return {
			subVisible: false,
			disabledSaved: true,
			progressKindId: '',
			progressKindName: '',
			tableSelVals: [],
			dataList: [],
			//当前页码
			pageIndex: 1,
			pageIndex2: 1,
			//当前记录数
			pageSize: 20,
			//总页数
			totalPage: 0,
			dataForm: {
				recNo: '',
				weeklyRecNo: '',
				dataType: '',
				sourceId: '',
				sourceType: 0,
				sort: 0,
				descContent: '',
				updUserName: '',
				dataKind: '',
			},
			dataType: '',
			subjectNo: '',
			major: '',
		};
	},
	methods: {
		init(weeklyRecNo, sort, dataType, subjectNo, major) {
			this.dataType = dataType
			this.subjectNo = subjectNo
			this.major = major
			this.dataForm = {
				recNo: '',
				workNo: $common.getItem("workNo"),
				weeklyRecNo: weeklyRecNo,
				dataType: dataType,
				sourceId: '',
				sourceType: '',
				subjectNo: subjectNo,
				major: major,
				sort: sort,
				descContent: '',
				updUserName: $common.getItem("userName"),
				dataKind: '1',
			}
			// 标题
			if (dataType === '010100') {
				this.progressKindName = '重要事项描述'
			} else if (dataType === '020300') {
				this.progressKindName = '详细进度情况'
			} else if (dataType === '030101') {
				this.progressKindName = '总体描述'
			} else if (dataType === '030102') {
				this.progressKindName = '总体描述'
			} else if (dataType === '030102') {
				this.progressKindName = '主要质量问题跟踪处理情况'
			} else if (dataType === '030201') {
				this.progressKindName = '总体描述'
			} else if (dataType === '030202') {
				this.progressKindName = '突出问题跟踪处理情况'
			} else if (dataType === '040000') {
				this.progressKindName = '文件审查情况'
			} else if (dataType === '050000') {
				this.progressKindName = '设计修改及审图意见落实情况'
			} else if (dataType === '060000') {
				this.progressKindName = '新增HSE情况'
			} else if (dataType === '070000') {
				this.progressKindName = '会议情况'
			} else if (dataType === '080000') {
				this.progressKindName = '其他需要说明的问题'
			} 
			this.$nextTick(() => {
				this.subVisible = true;
			})
			this.pageIndex2 = 1;
			this.getDataList();
		},
		// 获取数据列表
		getDataList() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/weeklyreportdescinfo/getLastRecordList",
				method: 'get',
				params: this.$http.adornParams({
					page: this.pageIndex,
					limit: this.pageSize,
					dataType: this.dataForm.dataType,
					subjectNo: this.subjectNo,
					major: this.major,
					dataType: this.dataForm.dataType,
					weeklyRecNo: this.dataForm.weeklyRecNo,
					workNo: $common.getItem("workNo"),
				})
			}).then(({
				data
			}) => {
				if (data && data.resultCode === 200) {
					this.dataList = data.body.recordList;
					this.totalPage = data.body.totalCount;
					this.pageIndex2 = this.pageIndex
				} else {
					this.dataList = []
					this.totalPage = 0
				}
			})
		},
		selGetDataList() {
			this.pageIndex = 1;
			this.getDataList();
		},
		// 每页数
		sizeChangeHandle(val) {
			this.pageSize = val;
			this.pageIndex = 1;
			this.getDataList();
		},
		// 当前页
		currentChangeHandle(val) {
			this.pageIndex = val;
			this.getDataList();
		},
		tableRowClassName({ row, rowIndex }) {
			return $common.tableRowClassName({ row, rowIndex });
		},
		selectRowBackground({ row }) {
			const checkIdList = this.tableSelVals.map((item) => item.recNo);
			if (checkIdList.includes(row.recNo)) {
				return {
					backgroundColor: "#fae8cb",
				};
			}
		},
		handleSelectionChange(selection) {
			this.tableSelVals = selection;
			if (selection.length > 0) {
				this.disabledSaved = false;
			} else {
				this.disabledSaved = true;
			}
		},
		dataSubmit() {
			let recordList = []
			for (var i = 0; i < this.tableSelVals.length; i++) {
				let record = {
					recNo: '',
					weeklyRecNo: this.dataForm.weeklyRecNo,
					dataType: this.dataType,
					sourceId: '',
					sourceType: '',
					sort: this.dataForm.sort + i,
					descContent: this.tableSelVals[i].descContent,
					subjectNo: this.tableSelVals[i].subjectNo,
					major: this.tableSelVals[i].major,
					updUserName: $common.getItem("userName"),
					workNo: $common.getItem("workNo"),
					photoRecords: this.tableSelVals[i].photoRecords,
					oriRecNo: this.tableSelVals[i].recNo
				}
				recordList.push(record)
			}
			let _url = "/business/weeklyreportdescinfo/saveBatch";
			this.$http({
				url: this.$store.state.httpUrl + _url,
				method: "post",
				data: this.$http.adornData({
					recordList: recordList
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.$message({
						message: "操作成功",
						type: "success",
						duration: 1500,
						onClose: () => {
							this.subVisible = false;
							this.$emit("refreshDataList");
						}
					});
				}
			});
		},
		headClass() {
			return 'background:#E1F1FF;color:#00428E;border:solid #dadada 1px;padding:1px;font-size:12px'
		},
	}
};
</script>

<style scoped="scoped">
.kind_row {
	background-color: rgb(243, 247, 247);
	padding: 10px 0 10px 15px;
	margin-bottom: 10px;
	margin-top: -8px;
}

.kind_label {
	color: black !important;
	font-weight: bold !important;
}

.kind_value_left {
	color: #3471b6 !important;
	font-weight: bold !important;
	margin-left: 10px;
}

/* 👇 核心修复：关闭按钮 绝对定位固定在弹窗顶部右上角 */
::v-deep .el-dialog__header {
  position: relative; /* 关键：让关闭按钮以头部为基准 */
  height: 50px !important;
  display: flex !important;
  align-items: center !important;
  padding: 0 20px !important;
  margin: 0 !important;
  background: #fff;
  border-bottom: 1px solid #e8e8e8;
}

::v-deep .el-dialog__title {
  line-height: 1 !important;
  font-size: 14px;
}

/* 👇 强制固定在顶部，永不乱跑 */
::v-deep .el-dialog__headerbtn {
  position: absolute !important;
  top: 15px !important;
  right: 15px !important;
  transform: none !important;
  margin: 0 !important;
}
</style>
